const GAP = 8
const MAX_HEIGHT = 350
const PINNED_PROPERTIES = [
  'position', 'top', 'bottom', 'left', 'right', 'width', 'maxHeight', 'margin', 'padding'
]

export class FloatingDropdown {
  #root
  #isOpen = false
  #inTopLayer = false

  constructor (root) {
    this.#root = root
  }

  open = () => {
    if (this.#isOpen) return

    this.#isOpen = true
    this.#place()

    window.addEventListener('scroll', this.#place, true)
    window.addEventListener('resize', this.#place)
  }

  close = () => {
    if (!this.#isOpen) return

    this.#isOpen = false
    window.removeEventListener('scroll', this.#place, true)
    window.removeEventListener('resize', this.#place)
    this.#release()
  }

  get #field () {
    return this.#root.querySelector('.choices__inner')
  }

  get #list () {
    return this.#root.querySelector('.choices__list--dropdown')
  }

  #place = () => {
    const field = this.#field
    const list = this.#list
    if (!field || !list) return

    this.#raiseToTopLayer(list)

    const anchor = field.getBoundingClientRect()

    Object.assign(list.style, {
      position: 'fixed',
      margin: '0',
      padding: '0',
      right: 'auto',
      left: `${anchor.left}px`,
      width: `${anchor.width}px`,
      ...this.#verticalPlacement(anchor, list)
    })
  }

  #raiseToTopLayer (list) {
    if (this.#inTopLayer || typeof list.showPopover !== 'function') return

    list.setAttribute('popover', 'manual')
    list.showPopover()
    this.#inTopLayer = true
  }

  #verticalPlacement (anchor, list) {
    const spaceBelow = window.innerHeight - anchor.bottom - GAP
    const spaceAbove = anchor.top - GAP
    const wanted = Math.min(list.scrollHeight, MAX_HEIGHT)

    if (wanted > spaceBelow && spaceAbove > spaceBelow) {
      return {
        top: 'auto',
        bottom: `${window.innerHeight - anchor.top + GAP}px`,
        maxHeight: `${Math.min(MAX_HEIGHT, spaceAbove)}px`
      }
    }

    return {
      top: `${anchor.bottom + GAP}px`,
      bottom: 'auto',
      maxHeight: `${Math.min(MAX_HEIGHT, spaceBelow)}px`
    }
  }

  #release () {
    const list = this.#list
    if (!list) return

    if (this.#inTopLayer) {
      this.#inTopLayer = false

      if (list.matches(':popover-open')) list.hidePopover()
      list.removeAttribute('popover')
    }

    PINNED_PROPERTIES.forEach((property) => { list.style[property] = '' })
  }
}
